angular.module 'zc.master.reports'

.controller 'MasterReportsCtrl', ($q, $scope, $translate, $filter, Page, projects, Report, MasterReportStats, Campaign, CampaignStats, MasterProject, SearchFilter, cronHours, currencies) ->
  Page.setBodyClass ''
  $translate('masterReports.list.reportList').then (translation) ->
    Page.setTitle translation

  $scope.MasterProject = MasterProject

  $scope.projects = projects
  $scope.filteredProjects = []
  $scope.sortProps = [['report.contribution_price', true]]
  $scope.sortReverse = true
  $scope.searchText = ''

  $scope.filters = SearchFilter.resolveFromLocation()
  $scope.filters.product_line = 'all'
  $scope.filters.contract_status = 'all'
  $scope.filters.search_term = ""

  $scope.project_status =
    all: $translate.instant('masterReports.list.all')
    before_trial: $translate.instant('masterReports.list.beforeTrial')
    trial: $translate.instant('masterReports.list.trial')
    terminated_after_trial: $translate.instant('masterReports.list.terminatedAfterTrial')
    contracted: $translate.instant('masterReports.list.contracted')
    terminated_after_contract: $translate.instant('masterReports.list.terminatedAfterContract')
    idle: $translate.instant('masterReports.list.idle')

  $scope.totalInvoiceAmount = 0

  SERVER_TIMEZONE = 'Asia/Tokyo'

  aggregateBaseTime =
    moment()
    .tz(SERVER_TIMEZONE)
    .subtract(cronHours.dailyReport, 'hours')
  $scope.currentPeriod =
    moment(aggregateBaseTime)
    .tz(SERVER_TIMEZONE)
    .startOf('month')
    .toDate()
  maxPeriod =
    moment(aggregateBaseTime)
    .tz(SERVER_TIMEZONE)
    .subtract(1, 'days')
    .startOf('month')
    .toDate()

  $scope.updateReportMode = () ->
    $scope.isTailPeriod =
      $scope.currentPeriod >= maxPeriod
    $scope.isUnfinishedPeriod =
      moment($scope.currentPeriod).tz(SERVER_TIMEZONE).valueOf() == moment(aggregateBaseTime).tz(SERVER_TIMEZONE).startOf('month').valueOf()
    $scope.isNormalPeriod = !$scope.isUnfinishedPeriod
    if $scope.isUnfinishedPeriod
      if aggregateBaseTime.date() > 1
        reportTime = moment(aggregateBaseTime).tz(SERVER_TIMEZONE).subtract(1, 'days')
      else
        reportTime = moment(aggregateBaseTime).tz(SERVER_TIMEZONE)
      $scope.latestReportDay = reportTime.startOf('day').toDate()
      $scope.beforeReportDay = reportTime.subtract(1, 'days').startOf('day').toDate()

  $scope.updateReportMode()

  $scope.nextMonth = () ->
    return if $scope.currentPeriod >= maxPeriod
    $scope.currentPeriod = moment($scope.currentPeriod).tz(SERVER_TIMEZONE).add(1, 'month').toDate()
    $scope.updateData()

  $scope.prevMonth = () ->
    $scope.currentPeriod = moment($scope.currentPeriod).tz(SERVER_TIMEZONE).subtract(1, 'month').toDate()
    $scope.updateData()

  $scope.setSortProp = (key) ->
    if $scope.sortProps[0][0] == key
      # reverse if already first on the list
      $scope.sortProps[0][1] = !$scope.sortProps[0][1]
    else
      # otherwise prepend and drop last
      $scope.sortProps.unshift [key, false]
      $scope.sortProps.splice(1)
    $scope.filterProjects()

  $scope.filterProjects = () ->
    $scope.filteredProjects = $filter('projectText')($scope.projects, $scope.filters.search_term)
    $scope.filteredProjects = filterByProductLine $scope.filteredProjects, $scope.filters.product_line
    $scope.filteredProjects = filterByProjectStatus $scope.filteredProjects, $scope.filters.contract_status
    $scope.filteredProjects = $filter('orderBy')($scope.filteredProjects, $scope.sortProps[0][0], $scope.sortProps[0][1])
    $scope.filteredProjects = $filter('emptyToEnd')($scope.filteredProjects, $scope.sortProps[0][0], $scope.sortProps[0][1])
    $scope.filteredProjects = $filter('filter')($scope.filteredProjects, {is_demo:false, product_line:'!zenclerk_s'}, true)

  $scope.calculateTotal = () ->
    $scope.totalInvoiceAmount = 0
    $scope.totalContributionPrice = 0
    _.map($scope.projects, (p) ->
      if p.report
        $scope.totalContributionPrice += p.report.contribution_price
        $scope.totalInvoiceAmount += p.report.invoice_amount
    )

  $scope.updateData = () ->
    $scope.updateReportMode()

    if $scope.isUnfinishedPeriod
      # get this month's date
      promises = _.map $scope.projects, (project) ->
        $q.all
          reports: Report.find
            apikey: project.apikey
            dimension: 'daily'
          ,
            match:
              # If contracted in middle of month, the report's begin_at is not
              # the first day of the month, so need to use $gte, $lt
              begin_at:
                $gte: new Date($scope.currentPeriod)
                $lt: moment($scope.currentPeriod).tz(SERVER_TIMEZONE).endOf("month").add(1, "days").startOf("month").toDate()
              start_at: $scope.latestReportDay
              device: null
              target: null
          day_before: Report.find
            apikey: project.apikey
            dimension: 'daily'
          ,
            match:
              # If contracted in middle of month, the report's begin_at is not
              # the first day of the month, so need to use $gte, $lt
              begin_at:
                $gte: new Date($scope.currentPeriod)
                $lt: moment($scope.currentPeriod).tz(SERVER_TIMEZONE).endOf("month").add(1, "days").startOf("month").toDate()
              start_at: $scope.beforeReportDay
              device: null
              target: null
              status: null
      $q.all(promises).then (results) ->
        for result, i in results
          project = projects[i]
          reports = _.groupBy result.reports, (d) -> d.status
          $scope.handleResponse(project, reports[null]?[0], reports["trial"]?[0], reports["contracted"]?[0], result.day_before[0])

    else

      promises = _.map $scope.projects, (project) ->
        Report.find
          apikey: project.apikey
          dimension: 'monthly'
        ,
          match:
            # If contracted in middle of month, the report's begin_at is not
            # the first day of the month, so need to use $gte, $lt
            begin_at:
              $gte: new Date($scope.currentPeriod)
              $lt: moment($scope.currentPeriod).tz(SERVER_TIMEZONE).endOf("month").add(1, "days").startOf("month").toDate()
            device: null
            target: null

      $q.all(promises).then (results) ->
        for result, i in results
          project = projects[i]
          reports = _.groupBy result, (d) -> d.status
          $scope.handleResponse(project, reports[null]?[0], reports["trial"]?[0], reports["contracted"]?[0])

  $scope.handleResponse = (project, report, trial, contracted, day_before_report) =>

    project.trial = trial || undefined
    project.contracted = contracted || undefined
    project.currencyObj = currencies[project.currency]

    if report
      project.report = report

      _.map [project.report, project.contracted, project.trial], (report) ->
        if report
          MasterReportStats.calculateInvoiceAmountRate(report)
          MasterReportStats.calculateGoalPercentage(report, project)

      # TODO: some better way to determine? percentage vs "how many days" comparison or so...
      # calculate yesterday's values and difference
      if day_before_report
        project.day_before_report = day_before_report
        project.day_before_invoice_amount_difference = report.invoice_amount - day_before_report.invoice_amount

    else

      # Unconditionally reset report to overwrite existing one
      project.report = undefined
      project.day_before_report = undefined

    $scope.filterProjects()
    $scope.calculateTotal()

  # ensure that projectRanks is available first
  $scope.MasterProject.getProjectRanks().then (res) ->
    $scope.updateData()

  $scope.$watch 'currentPeriod', (currentPeriod) ->
    $scope.range =
      start_at: currentPeriod
      end_at: moment(currentPeriod).tz(SERVER_TIMEZONE).add(1, 'month').toDate()

  filterByProductLine = (projects, productLine) ->
    if productLine == "all"
      projects
    else
      _.filter projects, (project) ->
        project.product_line == productLine

  filterByProjectStatus = (projects, contract_status) ->
    if contract_status == "all"
      projects
    else
      _.filter projects, (project) ->
        project.contract_status == contract_status

  $scope.resetSearchTerm = () ->
    $scope.filters.search_term = ""
    $scope.filterProjects()

  $scope.resetData = () ->
    $scope.filters.product_line = 'all'
    $scope.filters.contract_status = 'all'
    $scope.filters.search_term = ""
    $scope.filterProjects()



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.reports/list.controller.js.coffee